import { useMutation, useQueryClient } from 'react-query';
import HudVoucherService from '../../services/hudVoucherService';

const useSaveApprovalMutation = ({
  organizationId,
  propertyId,
  hudVoucherId,
  invalidateVoucherDetailQueries,
}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload) => {
      const service = new HudVoucherService();
      return service.saveApprovalData(
        organizationId,
        propertyId,
        hudVoucherId,
        payload,
        { fullError: true },
      );
    },
    {
      onSuccess: async () => {
        await invalidateVoucherDetailQueries();
        await queryClient.invalidateQueries('hudVouchers');
      },
      onError: () => {},
    },
  );
};

export default useSaveApprovalMutation;
